<template>
  <div class="time-event-dialog">
    <gs-modal
      v-model="visible"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      :title="isEdit?name+'-时间事件对象':'新建'+'-时间事件对象'"
      :has-form="true"
      class="time-event-dialog-modal"
      width="40%"
      top="10%"
      @close="close"
      @cancel="close"
      @confirm="handleConfirm"
    >
      <div>
        <a class="gs-modal-close" style="left: 90%;top: 13px"  @click="dialogHelp = true">
          <i class="el-icon-question" style="font-size: 17px;color: #737373"></i>
        </a>
      </div>
      <gs-tabs
        v-model="activeName"
        type="content-tab"
      >
        <gs-tab-pane
          label="常规"
          name="General"
        >
          <div class="general-form">
            <gs-form
              label-width="100px"
              label-position="left"
              gap="small"
            >
              <gs-form-item
                label="名称"
                prop="name"
              >
                <gs-input
                  ref="nameInput"
                  v-model="name"
                />
              </gs-form-item>

              <gs-form-item
                label="描述"
                prop="Description"
              >
                <gs-input v-model="description" />
              </gs-form-item>
            </gs-form>
          </div>
        </gs-tab-pane>
        <gs-tab-pane
          label="时间事件设置"
          name="timeEventSetting"
        >
          <div class="top-form">
            <div class="top-form-left">
              <gs-form
                label-width="100px"
                label-position="left"
                gap="small"
              >
                <gs-form-item
                  label="下一个事件"
                  prop="nextEvent"
                >
                  {{ nextEvent }}
                </gs-form-item>

                <gs-form-item
                  label="间隔类型"
                  prop="intervalType"
                >
                  <gs-select
                    v-model="form.intervalType"
                    class="doc-select"
                  >
                    <gs-option
                      v-for="item in intervalTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :disabled="item.disabled"
                      :value="item.value"
                    />
                  </gs-select>
                </gs-form-item>
                <gs-form-item
                  label="事件间隔"
                  prop="timeInterval"
                >
                  <gs-input-number
                    v-model="form.interval"
                    :disabled="form.intervalType!=='relative'"
                    min="0"
                  />
                  <gs-select
                    v-model="form.intervalUnit"
                    :disabled="form.intervalType!=='relative'"
                    class="doc-select"
                  >
                    <gs-option
                      v-for="item in intervalUnitOptions"
                      :key="item.value"
                      :label="item.label"
                      :disabled="item.disabled"
                      :value="item.value"
                    />
                  </gs-select>
                </gs-form-item>
              </gs-form>
            </div>
            <div class="top-form-right">
              <gs-form
                label-width="100px"
                label-position="left"
                gap="small"
              >
                <gs-form-item
                  label="开始时间"
                  prop="startTime"
                >
                  <gs-checkbox v-model="enableStartTime" />
                  <gs-date-picker
                    v-model="form.startTime"
                    :default-time="defaultTime"
                    :disabled="!enableStartTime"
                    type="date-time"
                  />
                </gs-form-item>
                <gs-form-item
                  label="结束时间"
                  prop="stopTime"
                >
                  <gs-checkbox v-model="enableStopTime" />
                  <gs-date-picker
                    v-model="form.stopTime"
                    :default-time="defaultTime"
                    :disabled="!enableStopTime"
                    type="date-time"
                  />
                </gs-form-item>
              </gs-form>
            </div>
          </div>
          <div class="middle-form">
            <div class="middle-form-left">
              <gs-form
                label-width="100px"
                label-position="left"
                gap="small"
              >
                <gs-form-item
                  label="每月的事件(天)"
                  prop="monthlyDay"
                >
                  <gs-select
                    v-model="form.monthlyDay"
                    :disabled="form.intervalType!=='onceMonth'&&form.intervalType!=='onceYear'"
                    class="doc-select"
                  >
                    <gs-option
                      v-for="item in monthlyDayOptions"
                      :key="item.value"
                      :label="item.label"
                      :disabled="item.disabled"
                      :value="item.value"
                    />
                  </gs-select>
                </gs-form-item>
              </gs-form>
            </div>
            <div class="middle-form-right">
              <gs-form
                label-width="100px"
                label-position="left"
                gap="small"
              >
                <gs-form-item
                  label="每月的事件(顺序)"
                  prop="monthlyOrder"
                >
                  <gs-select
                    v-model="form.monthlyOrder"
                    :disabled="form.intervalType!=='onceMonth'&&form.intervalType!=='onceYear'"
                    class="doc-select"
                  >
                    <gs-option
                      v-for="item in monthlyOrderOptions"
                      :key="item.value"
                      :label="item.label"
                      :disabled="item.disabled"
                      :value="item.value"
                    />
                  </gs-select>
                </gs-form-item>
              </gs-form>
            </div>
          </div>
          <div class="bottom-form">
            <div class="bottom-form-months">
              <fieldset>
                <legend>月份</legend>
                <gs-checkbox
                  v-model="checkAllMonths"
                  :indeterminate="isIndeterminateMonths"
                  :disabled="form.intervalType==='onceYear'"
                  class="custom-label"
                  @change="handleCheckAllMonths"
                >全选</gs-checkbox>
                <div>
                  <gs-checkbox-group
                    v-model="form.months"
                    :max="monthsCheckNum"
                    @change="handleCheckedMonthsChange"
                  >
                    <gs-checkbox
                      v-for="month in months"
                      :label="month"
                      :key="month"
                      style="margin:10px"
                    >{{ month }}</gs-checkbox>
                  </gs-checkbox-group>
                </div>
              </fieldset>
            </div>
            <div class="bottom-form-days">
              <fieldset>
                <legend>星期</legend>
                <gs-checkbox
                  :disabled="form.intervalType==='onceWeek'||form.intervalType==='onceYear'||form.intervalType==='onceMonth'"
                  v-model="checkAllDays"
                  :indeterminate="isIndeterminateDays"
                  class="custom-label"
                  @change="handleCheckAllDays"
                >全选</gs-checkbox>
                <div>
                  <gs-checkbox-group
                    v-model="form.days"
                    :max="daysCheckNum"
                    :disabled="form.intervalType==='onceYear'||form.intervalType==='onceMonth'"
                    @change="handleCheckedDaysChange"
                  >
                    <gs-checkbox
                      v-for="day in days"
                      :label="day"
                      :key="day"
                      style="margin:10px"
                    >{{ day }}</gs-checkbox>
                  </gs-checkbox-group>
                </div>
              </fieldset>
            </div>
          </div>
        </gs-tab-pane>
      </gs-tabs>
    </gs-modal>
    <gs-modal
      title="帮助"
      top="10%"
      width="42%"
      v-model = "dialogHelp"
      class="my-test-class"
      :before-close="handleCloseHelp">
      <span class="tab">常规</span><br>
      <hr />
      <span class="tit">名称：</span><span class="txt">趋势日志对象的名称</span><br>
      <span class="tit">描述：</span><span class="txt">该对的详细描述</span><br>
      <span class="tab">时间事件设置</span><br>
      <hr />
      <span class="tit">下一个事件</span><span class="txt"></span><br>
      <span class="tit">间隔类型：</span><span class="txt">可选自定义.每天一次,每周一次,每月一次,每年一次.</span><br>
      <span class="txt">自定义的时候可自己选择事件间隔的值和单位</span>
      <span class="txt">选择每天一次的时候***星期***会默认全选</span>
      <span class="txt">选择每周一次的时候会默认选中星期一</span>
      <span class="tit">开始时间：</span><span class="txt">指定该时间事件的开始执行时间.例如:2020/09/21 12:40:45</span><br>
      <span class="tit">结束时间：</span><span class="txt">指定该时间事件的结束执行时间.例如:2020/09/21 12:40:45</span><br>
      <!--<el-button @click="dialogHelp = false">取 消</el-button>
      <el-button type="primary" @click="dialogHelp = false">确 定</el-button>-->
      </span>
    </gs-modal>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
import moment from 'moment'
export default {
  data () {
    return {
      dialogHelp:false,
      isEdit: false,
      activeName: 'General',
      name: '',
      description: '',
      props: {
        label: 'name',
        disabled: 'type:folder'
      },
      form: {
        intervalType: 'relative',
        interval: 0,
        intervalUnit: 'second',
        startTime: moment(),
        stopTime: moment(),
        monthlyDay: '',
        monthlyOrder: '',
        months: [
          '一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'
        ],
        days: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
        actionObjects: []
      },
      intervalTypeOptions: [
        {
          value: 'relative',
          label: '自定义'
        },
        {
          value: 'onceDay',
          label: '每天一次'
        },
        {
          value: 'onceWeek',
          label: '每周一次'
        },
        {
          value: 'onceMonth',
          label: '每月一次'
        },
        {
          value: 'onceYear',
          label: '每年一次'
        }
      ],
      intervalUnitOptions: [
        {
          value: 'second',
          label: '秒'
        },
        {
          value: 'minute',
          label: '分'
        },
        {
          value: 'hour',
          label: '时'
        },
        {
          value: 'day',
          label: '天'
        },
        {
          value: 'week',
          label: '周'
        }
      ],
      monthlyDayOptions: [
        {
          value: 'MON',
          label: '星期一'
        },
        {
          value: 'TUE',
          label: '星期二'
        },
        {
          value: 'WED',
          label: '星期三'
        },
        {
          value: 'THU',
          label: '星期四'
        },
        {
          value: 'FRI',
          label: '星期五'
        },
        {
          value: 'SAT',
          label: '星期六'
        },
        {
          value: 'SUN',
          label: '星期天'
        },
        {
          value: 'NUMBER',
          label: '数字'
        }
      ],
      monthlyOrderOptions: [
        {
          value: 'FIRST',
          label: '第一'
        },
        {
          value: 'SECOND',
          label: '第二'
        },
        {
          value: 'THIRD',
          label: '第三'
        },
        {
          value: 'FOURTH',
          label: '第四'
        },
        {
          value: 'LAST',
          label: '最后'
        },
        {
          value: 'NUMBER',
          label: '数字'
        }
      ],
      months: [
        '一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'
      ],
      days: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
      defaultTime: moment(),
      enableStartTime: false,
      enableStopTime: false,
      isIndeterminateMonths: false,
      isIndeterminateDays: false,
      checkAllMonths: true,
      checkAllDays: true,
      monthsCheckNum: 12,
      daysCheckNum: 7
    }
  },
  computed: {
    ...mapState({
      visible: 'timeEventObjectShow',
      objectData: 'objectInfo',
      nodeData: 'nodeTree'
    }),
    nextEvent () {
      return ''
    }
  },
  watch: {
    'form.intervalType': function () {
      if (this.form.intervalType === 'onceWeek') {
        this.form.days = ['星期一']
        this.isIndeterminateDays = true
        this.daysCheckNum = 1
        this.monthsCheckNum = 12
      } else if (this.form.intervalType === 'onceMonth') {
        this.form.days = this.days
        this.isIndeterminateDays = false
        this.daysCheckNum = 7
        this.monthsCheckNum = 12
      } else if (this.form.intervalType === 'onceYear') {
        this.form.days = this.days
        this.isIndeterminateDays = false
        this.daysCheckNum = 7
        this.form.months = ['一月']
        this.isIndeterminateMonths = true
        this.monthsCheckNum = 1
      } else {
        this.daysCheckNum = 7
        this.monthsCheckNum = 12
      }
    },
    visible () {
      if (this.visible) {
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        this.activeName = 'General'
        if (JSON.stringify(this.objectData) !== '{}' && this.objectData.type === 'timeEvent') {
          this.form = this.objectData.attribute ? this.objectData.attribute : {}
          this.description = this.objectData.description ? this.objectData.description : ''
          this.name = this.objectData.name ? this.objectData.name : ''
          this.isEdit = true
          if (this.form.startTime !== -1) {
            this.form.startTime = moment(this.form.startTime)
            this.enableStartTime = true
          } else {
            this.form.startTime = moment(new Date())
            this.enableStartTime = false
          }
          if (this.form.stopTime !== -1) {
            this.form.stopTime = moment(this.form.stopTime)
            this.enableStopTime = true
          } else {
            this.form.stopTime = moment(new Date())
            this.enableStopTime = false
          }
          let months = []
          let days = []
          if (this.form.months !== null && this.form.months.length > 0) {
            if (this.form.months[0]) {
              months.push('一月')
            }
            if (this.form.months[1]) {
              months.push('二月')
            }
            if (this.form.months[2]) {
              months.push('三月')
            }
            if (this.form.months[3]) {
              months.push('四月')
            }
            if (this.form.months[4]) {
              months.push('五月')
            }
            if (this.form.months[5]) {
              months.push('六月')
            }
            if (this.form.months[6]) {
              months.push('七月')
            }
            if (this.form.months[7]) {
              months.push('八月')
            }
            if (this.form.months[8]) {
              months.push('九月')
            }
            if (this.form.months[9]) {
              months.push('十月')
            }
            if (this.form.months[10]) {
              months.push('十一月')
            }
            if (this.form.months[11]) {
              months.push('十二月')
            }
            this.form.months = months
          } else {
            this.form.months = []
          }
          if (this.form.days !== null && this.form.days.length > 0) {
            if (this.form.days[0]) {
              days.push('星期一')
            }
            if (this.form.days[1]) {
              days.push('星期二')
            }
            if (this.form.days[2]) {
              days.push('星期三')
            }
            if (this.form.days[3]) {
              days.push('星期四')
            }
            if (this.form.days[4]) {
              days.push('星期五')
            }
            if (this.form.days[5]) {
              days.push('星期六')
            }
            if (this.form.days[6]) {
              days.push('星期日')
            }
            this.form.days = days
          } else {
            this.form.days = []
          }
          this.checkAllMonths = this.form.months.length > 0
          this.isIndeterminateMonths = this.form.months.length > 0 && this.form.months.length < this.months.length
          this.checkAllDays = this.form.days.length > 0
          this.isIndeterminateDays = this.form.days.length > 0 && this.form.days.length < this.days.length
        } else {
          this.form = {
            intervalType: 'relative',
            interval: 0,
            intervalUnit: 'second',
            startTime: moment(),
            stopTime: moment(),
            monthlyDay: '',
            monthlyOrder: '',
            months: [
              '一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'
            ],
            days: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
            actionObjects: []
          }
          this.description = ''
          this.name = ''
          this.isEdit = false
          this.enableStartTime = false
          this.enableStopTime = false
          this.isIndeterminateMonths = false
          this.isIndeterminateDays = false
          this.checkAllMonths = true
          this.checkAllDays = true
          this.monthsCheckNum = 12
          this.daysCheckNum = 7
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      close: 'TIME_EVENT_OBJECT_HIDE'
    }),
    handleCheckAllMonths (event) {
      this.form.months = event.target.checked ? this.months : ['一月']
      this.isIndeterminateMonths = false
    },
    handleCheckedMonthsChange (value) {
      let checkedCount = value.length
      this.checkAllMonths = checkedCount > 0
      this.isIndeterminateMonths = checkedCount > 0 && checkedCount < this.months.length
    },
    handleCheckAllDays (event) {
      this.form.days = event.target.checked ? this.days : ['星期一']
      this.isIndeterminateDays = false
    },
    handleCheckedDaysChange (value) {
      let checkedCount = value.length
      this.checkAllDays = checkedCount > 0
      this.isIndeterminateDays = checkedCount > 0 && checkedCount < this.days.length
    },
    beforeConfirm (e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      if (this.enableStartTime && this.enableStopTime && this.form.startTime > this.form.stopTime) {
        this.$Message.warning('开始时间不能大于结束时间!')
        return
      }
      if (this.form.intervalType === 'onceMonth' || this.form.intervalType === 'onceYear') {
        if (!this.form.monthlyDay) {
          this.$Message.warning('请选择每月的事件(天)')
          return
        }

        if (!this.form.monthlyOrder) {
          this.$Message.warning('请选择每月的事件(顺序)')
          return
        }

        if (!this.form.months || this.form.months.length === 0) {
          this.$Message.warning('必须至少选择一个月份')
          return
        }
      }

      if (this.form.intervalType === 'relative') {
        if (!this.form.interval) {
          this.$Message.warning('事件间隔时间不能为空')
          return
        }

        if (!this.form.intervalUnit) {
          this.$Message.warning('事件间隔时间单位不能为空')
          return
        }

        if (!this.form.months || this.form.months.length === 0) {
          this.$Message.warning('必须至少选择一个月份')
          return
        }

        if (!this.form.days || this.form.days.length === 0) {
          this.$Message.warning('必须至少选择一个星期')
          return
        }
      }

      if (this.form.intervalType === 'onceDay' || this.form.intervalType === 'onceWeek') {
        if (!this.form.months || this.form.months.length === 0) {
          this.$Message.warning('必须至少选择一个月份')
          return
        }

        if (!this.form.days || this.form.days.length === 0) {
          this.$Message.warning('必须至少选择一个星期')
          return
        }
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm () {
      let startTime = this.form.startTime.valueOf()
      let stopTime = this.form.stopTime.valueOf()
      // 未设置start,起始时间为-1
      if (!this.enableStartTime) {
        startTime = -1
      }
      // 未设置end,结束时间为-1
      if (!this.enableStopTime) {
        stopTime = -1
      }
      let months = [false, false, false, false, false, false, false, false, false, false, false, false]
      let days = [false, false, false, false, false, false, false]
      if (this.form.months) {
        this.form.months.forEach(e => {
          switch (e) {
            case '一月':
              months[0] = true
              break
            case '二月':
              months[1] = true
              break
            case '三月':
              months[2] = true
              break
            case '四月':
              months[3] = true
              break
            case '五月':
              months[4] = true
              break
            case '六月':
              months[5] = true
              break
            case '七月':
              months[6] = true
              break
            case '八月':
              months[7] = true
              break
            case '九月':
              months[8] = true
              break
            case '十月':
              months[9] = true
              break
            case '十一月':
              months[10] = true
              break
            case '十二月':
              months[11] = true
              break
            default:
              break
          }
        })
      }

      if (this.form.days) {
        this.form.days.forEach(e => {
          switch (e) {
            case '星期一':
              days[0] = true
              break
            case '星期二':
              days[1] = true
              break
            case '星期三':
              days[2] = true
              break
            case '星期四':
              days[3] = true
              break
            case '星期五':
              days[4] = true
              break
            case '星期六':
              days[5] = true
              break
            case '星期日':
              days[6] = true
              break
            default:
              break
          }
        })
      }

      let attribute = {}
      switch (this.form.intervalType) {
        case 'relative':
          attribute = {
            'startTime': startTime,
            'stopTime': stopTime,
            'intervalType': this.form.intervalType,
            'interval': this.form.interval,
            'intervalUnit': this.form.intervalUnit,
            'months': months,
            'days': days,
            'actionObjects': this.form.actionObjects
          }
          break
        case 'onceDay':
        case 'onceWeek':
          attribute = {
            'startTime': startTime,
            'stopTime': stopTime,
            'intervalType': this.form.intervalType,
            'months': months,
            'days': days,
            'actionObjects': this.form.actionObjects
          }
          break
        case 'onceMonth':
        case 'onceYear':
          attribute = {
            'startTime': startTime,
            'stopTime': stopTime,
            'intervalType': this.form.intervalType,
            'monthlyDay': this.form.monthlyDay,
            'monthlyOrder': this.form.monthlyOrder,
            'months': months,
            'actionObjects': this.form.actionObjects
          }
          break
        default:
          break
      }

      if (this.objectData.id && this.objectData.type === 'timeEvent') {
        let param = {
          'id': this.objectData.id,
          'name': this.name,
          'type': this.objectData.type,
          'value': this.objectData.value,
          'parentId': this.objectData.parentId,
          'description': this.description,
          'attribute': attribute
        }
        service.renamePoint(param).then(res => {
          this.$Message.success('修改成功')
          this.close()
        }).catch(err => {
          this.$Message.error(err.message)
        })
      } else {
        let param = {
          'name': this.name,
          'type': 'timeEvent',
          'parentId': this.objectData.id,
          'description': this.description,
          'attribute': attribute
        }
        service.newAddPoint(param).then(res => {
          this.$Message.success('添加成功')
          this.close()
        }).catch(err => {
          this.$Message.error(err.message)
        })
      }
    },
    beforeClose (e, done) {
      // done(false)可以阻止modal关闭
      this.close()
    },
    handleCloseHelp(){
      this.dialogHelp = false
    },
    handleCloseHelp(){
      this.dialogHelp = false
    }
  }
}
</script>
<style lang="scss" scope>
.time-event-dialog {
  &-modal {
    .gs-select {
      width: 70%;
    }
    fieldset {
      padding: 12px;
      border-radius: 5px;
      border: solid 2px #d9d9d9;
    }
    .gs-radio-group {
      line-height: 24px;
    }
    .limit {
      display: flex;
      width: 100%
    }
    .page-checkbox {
      margin-bottom: 24px
    }
    .checkbox {
      margin-bottom: 12px
    }
    .bottom-btn {
      text-align: center
    }
    .object-form {
      border-bottom: solid 1px #d9d9d9
    }
    .time-form {
      margin-top: 12px
    }
    .gs-tabs-content {
      position: static;
      overflow: hidden;
      padding: 16px 0;
    }
    .top-form {
      display: flex
    }
    .top-form-left {
      width: 50%
    }
    .top-form-right {
      width: 50%;
      padding-left: 24px;
    }
    .middle-form {
      display: flex
    }
    .middle-form-left {
      width: 50%
    }
    .middle-form-right {
      width: 50%;
      padding-left: 24px;
    }
  }
}
.treeList {
      height: 300px;
      overflow: auto;
      margin-bottom: 12px;
      padding: 12px;
      border: solid 1px #d9d9d9;
      border-radius: 1px;
}

.el-input__inner {
  border: solid 1px #d9d9d9;
}

</style>



// WEBPACK FOOTER //
// src/components/timeEvent/timeEventObject.vue